{
  "steplist": "Lépések listája"
}
